import { Injectable, inject } from '@angular/core';
import { PreInitSettingsService } from '../settings/pre-init-setting.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CryptoResponseDto } from './crypto-response.dto';
import { CryptoDocsResponseDto } from './crypto-docs-response.dto';

@Injectable({
  providedIn: 'root',
})
export class CryptoService {
  middlewareUrl: string;
  accountPath: string;
  private preInitSettingsService = inject(PreInitSettingsService);
  private httpClient = inject(HttpClient);

  constructor() {
    this.middlewareUrl = this.preInitSettingsService.getSettings().middleWare.middlewareUrl;
    this.accountPath = this.preInitSettingsService.getSettings().middleWare.accountPath;
  }

  rsaEncryptData(stringToEncrypt: string): Observable<CryptoResponseDto> {
    const body = {
      stringToEncrypt
    };
    const endpoint = `${this.middlewareUrl}${this.accountPath}rsa-encrypt-data`;
    return this.httpClient.post<CryptoResponseDto>(endpoint, body);
  }

  mwcEncryptData(stringToEncrypt: string, settingPrefix? : string ): Observable<CryptoResponseDto> {
    const body = {
      stringToEncrypt,
      settingPrefix
    };
    const endpoint = `${this.middlewareUrl}${this.accountPath}mwc-encrypt-data`;
    return this.httpClient.post<CryptoResponseDto>(endpoint, body);
  }

   mwcDecryptData(dataToDecrypt: string, settingPrefix? : string ): Observable<CryptoDocsResponseDto> {
    const body = {
      dataToDecrypt,
      settingPrefix
    };
    const endpoint = `${this.middlewareUrl}${this.accountPath}mwc-decrypt-data`;
    return this.httpClient.post<CryptoDocsResponseDto>(endpoint, body);
  }
}
